<template>
  <b-card-text
    v-bind="$attrs"
    v-on="mountEventListeners">
    <slot />
  </b-card-text>
</template>

<script>
export default {
  name: 'CoozzyCardText',
  inheritAttrs: false,
  computed: {
    mountEventListeners() {
      return this.$listeners
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
